import type { AdminRole } from "@upclaim/sdk/src/extra-types";

/**
 * Labels from the Vue utils/config/constants/admin-roles.ts — the wording used by
 * the Users page. Deliberately distinct from src/lib/admin-roles.ts whose labels
 * are the sidebar-footer wording (e.g. LAWYER "Juriste" vs "Avocat" here).
 */
// biome-ignore-start lint/style/useNamingConvention: AdminRole enum keys
export const adminRoleLabels: Record<AdminRole, string> = {
  UPCLAIM_DIRECTION: "Direction Upclaim",
  UPCLAIM_JURIST: "Juriste Upclaim",
  UPCLAIM_TECH: "Tech Upclaim",
  LAWYER: "Avocat",
  PLEADING_LAWYER: "Avocat postulant",
  CUSTOMER_ADMIN: "Administrateur",
  CUSTOMER_AGENT: "Agent",
  CUSTOMER_ACCOUNT_MANAGER: "Chargé de comptes (AM)",
  BUSINESS_TRAVEL_ADMIN: "Admin voyages d'affaires",
};
// biome-ignore-end lint/style/useNamingConvention: AdminRole enum keys

/** Roles a customer admin may hand out: its own kind, never Upclaim's. */
const CUSTOMER_ROLES: AdminRole[] = ["CUSTOMER_AGENT", "CUSTOMER_ACCOUNT_MANAGER", "CUSTOMER_ADMIN"];

/**
 * Roles offered when editing an account. The Upclaim direction gets every role but
 * BUSINESS_TRAVEL_ADMIN, retired in favour of CUSTOMER_ADMIN.
 */
export function assignableRoles(isUpclaimDirection: boolean): AdminRole[] {
  if (!isUpclaimDirection) {
    return CUSTOMER_ROLES;
  }
  return (Object.keys(adminRoleLabels) as AdminRole[]).filter((role) => role !== "BUSINESS_TRAVEL_ADMIN");
}
